import React from "react";
import {
    Segment, Image
} from 'semantic-ui-react';
import "../../../assets/styles/styles.css";
// import "../../assets/styles/styles.css";

const Loader = (props) => {

    return (

        <div className="loaderContainer">
            <Image style={{ width: '150px',borderRadius: '5px'  }} src={require('../../../assets/images/loading.gif')} />
        </div>
    );
}

export default Loader;

Loader.displayName = 'Loader';